/**
 * @file コンポーネント：フォームプルダウン DOM管理
 */

// ライブラリ読み込み
import React from "react";

// スタイル読み込み
import {
    StyledPulldown,
    StyledPulldownSelect,
    StyledPulldownSelectOption,
} from "./style";

// Presenterを返す
export const Presenter = (props) => {
    // ReactDOM
    return (
        <StyledPulldown
            className={props.isWide === true && "is-wide"}
            data-on-color={props.onColor}
        >
            <StyledPulldownSelect
                data-on-color={props.onColor}
                defaultValue={props.value}
                disabled={props.disabled}
                id={props.id}
                name={props.name}
                onChange={props.onChange}
                ref={props.refSelect}
                title={props.title}
            >
                {props.list.map((item, index) => (
                    <StyledPulldownSelectOption
                        key={"option-" + index}
                        title={item.title}
                        value={item.value}
                    >
                        {item.text}
                    </StyledPulldownSelectOption>
                ))}
            </StyledPulldownSelect>
        </StyledPulldown>
    );
};
